import { render, staticRenderFns } from "./SelectCourseGroupsTable.vue?vue&type=template&id=ceb287f2"
import script from "./SelectCourseGroupsTable.vue?vue&type=script&lang=js"
export * from "./SelectCourseGroupsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports